import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    answer: {}
}

const answerReducer = createSlice({
    name: 'answers',
    initialState,
    reducers: {
        setAnswer: (state, action) => {
            const { questionId, option } = action.payload;
            const answers = state.answer;
            state.answer = {
                ...answers,
                [questionId]: option
            }
        },
        // clearAnswer: () => initialState
        clearAnswer: (state) => {
            Object.assign(state, initialState); // Reset state
        },
    }
});

export const { setAnswer, clearAnswer } = answerReducer.actions;
export default answerReducer.reducer